import React from 'react';
import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';
import IconSvg from '@/components/common/IconSvg';
import { HeaderRowSchema } from './HeaderRow.styles';

export const RunnerDetails: CSSObject = {
  color: 'beta.500',
};

export const RunnerDescription: CSSObject = {
  color: 'gray.400',
  fontWeight: '700',
  textTransform: 'capitalize',
};

export const BetOdds: CSSObject = {
  color: 'gray.700',
};

export const TextBarrierNumber: CSSObject = {
  color: 'beta.500',
};

export const BetReturn = (status: TBetReturn): CSSObject => ({
  color: () => {
    switch (status) {
      case 'won':
        return 'alpha.800';
      case 'lost':
        return 'beta.300';
      case 'voided':
        return 'white';
      case 'cancelled':
        return 'white';
      case 'pending':
        return 'orange.700';
      default:
    }
  },
  bg: () => {
    switch (status) {
      case 'won':
        return 'alpha.400';
      case 'lost':
        return 'beta.700';
      case 'voided':
        return 'gamma.900';
      case 'cancelled':
        return 'gray.400';
      case 'pending':
        return 'gamma.500';
      default:
    }
  },
});

export const HeaderSvg: CSSObject = {
  color: 'beta.500',
  boxSize: '5',
};

export const BetMultiIcon: CSSObject = {
  boxSize: '5',
  color: 'alpha.600',
};

export const MultiIcon = () => (
  <IconSvg
    name="MultiIconVolcanobet"
    className="svgIcon"
    boxSize="6"
    mb="1.5"
  />
);

export const headerRowStyles: HeaderRowSchema = {
  headerRowSvg: {
    fill: 'white',
  },
};
